import React from 'react';
import { CssCheckbox } from './vbCssComponents';

class VBCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      checked: props.initial
    };
  }

  handleChange = () => {
    // Destructure the 'checked' property from the component's state
    const { checked } = this.state;
    // Update the component's state to toggle the 'checked' property
    this.setState({ checked:!checked });
    // Call the 'onClick' function passed as a prop to the component
    if(this.props.onClick){
      this.props.onClick(!checked);
    }
    if(this.props.onChange){
      this.props.onChange(!checked);
    }
  }

  render() {
    return (
      <div>
        <div className="w-100 d-flex">
          <CssCheckbox className={`d-flex align-items-flex-start`}> 
            <div className={`checkmark me-2 ${this.props.classNames}`} onClick={!this.props.disabled ? this.handleChange : null}>
            {this.state.checked ? <img src={`${Window.static_path}img/icons/checkmark.svg`} width="20" height="20" className={this.props.checkFilter} alt="" />:null}
            </div>
            
            {this.props.label}
          </CssCheckbox>
        </div>
      </div>
    );
  }
}

VBCheckbox.defaultProps = {
  checkFilter: 'primary-dark-filter',
  classNames: ''
};

export default VBCheckbox;